import IApplicationState from 'app/types/state';
import { IGroupsState, IGroupsSelector } from 'app/ducks/groups/types';
import _ from 'lodash';
import { getCompetitionById } from 'app/ducks/competitions/selectors';

function mapSelect(state, n): { value: string; label: string } {
  const sa = state.groups.groupsById[n];
  if (sa) {
    return { id: sa.id, name: sa.name };
  }
  return {};
}

export function getGroupsFilteredByTagInSelectFormat(
  state: IApplicationState,
  tagId,
): any {
  const { groupsById }: IGroupsState = state.groups;
  const groups = _.filter(groupsById, { tags: [tagId] });
  const sortedGroups = _.sortBy(groups, (o) => o.name);
  const mappedGroups = _.map(sortedGroups, (n) => mapSelect(state, n.id));
  return mappedGroups;
}

export function getGroupsFilteredByCompetitionById(groupsById, competitionId) {
  const filteredGroups = _.filter(groupsById, {
    competition: { id: competitionId },
  });
  const groupIds = _.map(filteredGroups, 'id');
  const parsedGroupsById = _.pick(groupsById, groupIds);

  return {
    groupsById: parsedGroupsById,
    groupIds,
  };
}

export function getGroupsByIdInSelectFormat(state): any {
  const { groupsById } = state.groups;
  const sortedGroups = _.sortBy(groupsById, (o) => o.name);
  const mappedTeams = _.map(sortedGroups, (n) => mapSelect(state, n.di));
  return mappedTeams;
}

export function getGroup(state, group): any {
  if (group != null) {
    const findCompetition = !_.isEmpty(group.competition)
      ? getCompetitionById(state, group.competition.id)
      : {};
    return {
      ...group,
      competition: {
        ...findCompetition,
      },
    };
  }
  return {};
}

export function getGroupById(state, id): any {
  if (state.groups.groupsById !== undefined && id != null) {
    return getGroup(state, state.groups.groupsById[id]);
  }
  return {};
}

export function getCurrentGroup(state: IApplicationState): any {
  if (
    state.groups.groupsById !== undefined
    && state.groups.currentGroupId !== undefined
  ) {
    return state.groups.groupsById[state.groups.currentGroupId];
  }
  return {};
}

export function getCurrentFormGroup(state: IApplicationState): any {
  return {
    ...getCurrentGroup(state),
    ...state.groups.requestedData,
  };
}

export function getGroups(state): IGroupsSelector {
  return {
    ...state.groups,
    currentGroup: {
      ...getCurrentGroup(state),
    },
    groupsByIdInSelectFormat: getGroupsByIdInSelectFormat(state),
    groupsFilteredByTagInSelectFormat: (tagId): any => getGroupsFilteredByTagInSelectFormat(state, tagId),
  };
}

export function getFinancialStatusHumanised(group) {
  let financialStatusHumanised = '';
  if (group.overdueTotalPaymentsTotalCount > 0) {
    financialStatusHumanised = 'Overdue';
  } else if (group.pendingTotalPaymentsTotalCount > 0) {
    financialStatusHumanised = 'Owing';
  }
  return financialStatusHumanised;
}

export function getGroupSummary(group): any {
  const financialStatusHumanised = getFinancialStatusHumanised(group);
  const groupSummary = {
    id: group.id,
    groupName: group.name,
    competitionName: group.competitionName,
    seasonName: group.seasonName,
    sectionName: group.sectionName,
    updatedAt: group.updatedAt,
    financialStatus: {
      owingNumber: group.pendingTotalPaymentsTotalCount,
      overdueNumber: group.overdueTotalPaymentsTotalCount,
    },
    financialStatusHumanised,
    organisation: group.organisation?.id,
    competitionId: group.competition?.id,
    tags: group.tagList,
    groupType: _.capitalize(group.groupType),
  };
  return groupSummary;
}

export function getGroupsByObjectId(groups, object, objectId): any {
  if (groups.groupsById !== undefined && objectId != null) {
    const filteredGroups = _.filter(groups.groupsById, {
      [object]: { id: objectId },
    });

    const groupIds = _.map(filteredGroups, 'id');
    const groupsById = _.pick(groups.groupsById, groupIds);

    return {
      groupsById,
      groupIds,
    };
  }
  return {};
}

export function getGroupsFilteredBySectionInSelectFormat(
  state,
  sectionId,
): any {
  const { groupsById } = state.groups;
  const groups = _.filter(groupsById, { section: sectionId });
  const mappedGroups = _.map(groups, (n) => mapSelect(state, n.id));
  return mappedGroups;
}

export function getGroupsFilteredByTypeInSelectFormat(groups, groupType) {
  const { groupsById } = groups;
  const filteredGroups = _.filter(groupsById, { groupType });
  const mappedGroups = _.map(filteredGroups, (n) => mapSelect({ groups }, n.id));
  return mappedGroups;
}

export function getGroupsByIds(groupsById, groupIds): any {
  if (groupsById !== undefined && groupIds != null) {
    return _.pick(groupsById, groupIds);
  }
  return {};
}

export function getGroupsByIdsAndType(groupsById, groupIds, groupType): any {
  if (groupsById !== undefined && groupIds != null && groupType != null) {
    return _.filter(_.pick(groupsById, groupIds), { groupType });
  }
  return {};
}

export function getClubsAndTeamsByIds(groupsById, groupIds): any {
  if (groupsById !== undefined && groupIds != null) {
    const arrTeams = getGroupsByIdsAndType(groupsById, groupIds, 'team');
    const teamsById = _.keyBy(arrTeams, 'id');
    const teamGroupsIds = _.flatMap(teamsById, (t) => _.map(t.groups, (b) => b.id));
    // console.log(teamGroupsIds);
    const arrClubs = getGroupsByIdsAndType(groupsById, teamGroupsIds, 'club');
    // console.log(arrClubs);
    const clubsById = _.keyBy(arrClubs, 'id');
    // const clubGroupsIds = _.map(clubsById, t => t.groups);

    // console.log(teamsById, clubsById);
    return { teams: teamsById, clubs: clubsById };
  }
  return {};
}
